import * as React from "react";
const SvgFiRrTaxi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-taxi_svg__a)">
      <path
        fill="#062147"
        d="M23 11a1 1 0 0 0 0-2h-1.4l-.77-2.481a4.96 4.96 0 0 0-4.13-3.467A4.98 4.98 0 0 0 12.117 0h-.234A4.98 4.98 0 0 0 7.3 3.052a4.96 4.96 0 0 0-4.128 3.466L2.4 9H1a1 1 0 0 0 0 2h.781l-.715 2.3A3.958 3.958 0 0 0 2 19.444V21a3 3 0 0 0 6 0v-1h8v1a3 3 0 0 0 6 0v-1.556a3.958 3.958 0 0 0 .934-6.142L22.219 11zM11.883 2h.234a3 3 0 0 1 2.226 1H9.657a2.99 2.99 0 0 1 2.226-1m-6.8 5.11A2.99 2.99 0 0 1 7.947 5h8.106a2.99 2.99 0 0 1 2.865 2.111l1.532 4.934A4 4 0 0 0 20 12H4q-.226.009-.45.045zM6 21a1 1 0 1 1-2 0v-1h2zm14 0a1 1 0 0 1-2 0v-1h2zm0-3H4a2 2 0 1 1 0-4v1a1 1 0 1 0 2 0v-1h12v1a1 1 0 0 0 2 0v-1a2 2 0 0 1 0 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-taxi_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTaxi;
